// Mutation hook - soft delete skrzynki mailowej zalogowanego handlowca
// DELETE /api/ui/sales-crm/mailbox/my-mailbox
// Soft delete (D24): 30-dniowy grace period przed crypto-shredding.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { getMyMailboxQueryKey } from 'api/endpoints/useGetMyMailbox';

interface IDeleteMyMailboxResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

const deleteMyMailbox = (): Promise<IDeleteMyMailboxResponse> =>
  axios.delete('/sales-crm/mailbox/my-mailbox');

export const useDeleteMyMailbox = (
  options?: UseMutationOptions<IDeleteMyMailboxResponse, IError, void>
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteMyMailboxResponse, IError, void>(deleteMyMailbox, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(getMyMailboxQueryKey);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
